import React from "react";
import {
  ElevateReviewLogo,
  GoogleReviewLogo,
  ReviewQuotes,
  ReviewSectionContainer,
  ReviewSectionWrapper,
  ReviewText,
  ReviewTextTitle,
} from "../styles/components";
import { Box, Divider, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ReviewSection = () => {
  return (
    <ReviewSectionWrapper>
      <ReviewSectionContainer>
        <ReviewQuotes
          src="/images/landingpagev2/double-quotes.svg"
          alt="Quotes icon"
        />
        <Box
          sx={{
            maxWidth: "100%",
            margin: "0 auto",
            textAlign: "left",
            gap: "16px",
            display: "flex",
            flexDirection: "column",
            mt: 2,
          }}
        >
          <ReviewText>What Texans say | Phillip R.</ReviewText>
          <ReviewTextTitle variant="h3">
            Everything is always excellent. I have been with Constellation a few
            years now. I've been very happy with their rates and their customer
            service is truly outstanding.
          </ReviewTextTitle>
        </Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
            gap: { xs: 2, md: 4 },
            alignItems: "center",
            mt: { xs: 2, md: 4 },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
            <Box>
              <img src="/images/landingpagev2/icons/google-review.svg" alt="Elevate reviews icon" width={80} height={80} />
            </Box>
            <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center"}}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexDirection: "column", textAlign:"left" }} >
                <Typography
                variant="body2"
                sx={{
                  color: "#576367",
                  fontFamily: "Inter",
                  fontSize: "22px",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "20px",
                  letterSpacing: "-0.15px",
                  textAlign:"left",
                  width: "100%",
                }}
              >
                Google Reviews
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 , justifyContent:"flex-start", width: "100%"}}>
                <img src="/images/landingpagev2/icons/rating.svg" alt="Rating icon" width={"136px"} height={"24px"} />
                <Typography variant="body2" sx={{ color: "#1A1A1A", fontWeight: 500, fontSize: { xs: "16px", md: "18px" }, lineHeight: "20px" }}>
                  4.6
                </Typography>
                
              </Box>
              </Box>
              <Typography variant="body2" sx={{ color: "#576367", fontWeight: 400, fontSize: { xs: "12px", md: "14px" }, lineHeight: "20px" }}>
                  3,000+ ratings
                </Typography>
            </Box>
          </Box>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              width: 0,
              height: 93,
              borderWidth: "1.5px",
              border: "1.5px solid #2372B94D",
              alignSelf: "center",
            }}
          />
          <ElevateReviewLogo
            src="/images/landingpagev2/electricity-rates.png"
            alt="Electricity review icon"
          />
        </Box>
      </ReviewSectionContainer>
    </ReviewSectionWrapper>
  );
};

export default ReviewSection;
